import PageHeader from "@/components/PageHeader";
import { useProjectBreadcrumb } from "../hooks/useProjectBreadcrumb";
import { ProjectDetailsAndNavigation } from "./ProjectDetailsAndNavigation";
import { useProjectQuery } from "@/modules/projects/hooks/useProjectQuery";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";

export default function ProjectBasicView() {
  const projectId = useProjectId();
  const query = useProjectQuery(projectId);
  const breadcrumbItems = useProjectBreadcrumb(query);

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <ProjectDetailsAndNavigation />
    </>
  );
}
